import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Button,
} from 'reactstrap';

import { refreshFiles } from '../../actions/Files';

import { APIcreateFilesGroup } from '../../api/Files';
import { APIemptyUserTrash } from '../../api/User';

import { addFlashMessage } from '../../helpers/FlashMessages';

import ErrorBoundary from '../ErrorBoundary';
import ProcessingSpinner from '../ProcessingSpinner';
import ProcessingProgress from '../ProcessingProgress';

const EmptyTrashModal = ({ handleClose, backendActions, reloadFiles }) => {
  const intl = useIntl();

  const [loading, setLoading] = useState(false);
  const [fileGroupUuid, setFileGroupUuid] = useState(null);

  const progress = backendActions[`progress_${fileGroupUuid}`] || { total: 0, done: 0 };

  const handleEmptyTrash = () => {
    setLoading(true);
    APIcreateFilesGroup({
      type: 'empty_trash',
      data: {},
    }).then((response) => {
      setFileGroupUuid(response.data.uuid);
      APIemptyUserTrash(response.data.uuid).then(() => {
        handleClose();
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({
            defaultMessage: 'Trash is now empty',
          }),
        });
        reloadFiles();
      });
    });
  };

  return (
    <ErrorBoundary>
      <ModalHeader
        toggle={handleClose}
        className="modal-header-center"
      >
        {intl.formatMessage({ defaultMessage: 'Empty Trash' })}
      </ModalHeader>
      <ModalBody>
        <Form className="select-collection-form">
          <FormGroup>
            <p className="warning">
              <i className="far fa-triangle-exclamation fa-2x" />
              {intl.formatMessage({ defaultMessage: 'Are you sure you want to empty the trash?' })}
            </p>
            <p>{intl.formatMessage({ defaultMessage: 'This will permanently delete all files in the trash. This can not be undone.' })}</p>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter className="justify-r">
        <div className="buttons-group">
          <Button
            color="link"
            disabled={loading}
            onClick={handleClose}
          >
            {intl.formatMessage({ defaultMessage: 'Cancel' })}
          </Button>
          <Button
            color="primary"
            disabled={loading}
            onClick={() => handleEmptyTrash()}
          >
            <ProcessingSpinner show={loading} />
            {intl.formatMessage({ defaultMessage: 'Confirm' })}
            <ProcessingProgress show={loading && !!progress} progress={progress} />
          </Button>
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  backendActions: state.App.backendActions,
});

const mapDispatchToProps = (dispatch) => ({
  reloadFiles: () => {
    dispatch(refreshFiles());
  },
});

EmptyTrashModal.propTypes = {
  reloadFiles: PropTypes.func.isRequired,
  backendActions: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmptyTrashModal);
